import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SEED_TRAINING_LOG, type TrainingLogEntry } from "@/models/training.model";

export type TrainingView = "admin" | "agent";

export type ChatMessage = {
    id: string;
    role: "user" | "coach";
    text: string;
    at: number;
};

type TrainingState = {
    view: TrainingView;
    /** Ask Your Coach thread — intentionally not persisted; resets on reload. */
    chat: ChatMessage[];
    /** Admin coaching action log — recent activity taken from Suggested Actions. */
    log: TrainingLogEntry[];
};

const initialState: TrainingState = {
    view: "agent",
    chat: [],
    log: SEED_TRAINING_LOG,
};

const trainingSlice = createSlice({
    name: "training",
    initialState,
    reducers: {
        setView(state, action: PayloadAction<TrainingView>) {
            state.view = action.payload;
        },
        sendCoachMessage(state, action: PayloadAction<Omit<ChatMessage, "id" | "at">>) {
            state.chat.push({
                id: `msg-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
                at: Date.now(),
                ...action.payload,
            });
        },
        clearChat(state) {
            state.chat = [];
        },
        addLog(state, action: PayloadAction<Omit<TrainingLogEntry, "id" | "when">>) {
            state.log.unshift({
                id: `log-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
                when: "Just now",
                ...action.payload,
            });
            if (state.log.length > 30) state.log.length = 30;
        },
    },
});

export const { setView, sendCoachMessage, clearChat, addLog } = trainingSlice.actions;
export default trainingSlice.reducer;
